<template>
  <div class="company-cruise-detail j_main bg-[#F7F8FC]" v-scroll="handleScroll">
    <div class="flex w-[1366px] mx-auto">
      <!-- 左侧导航 -->
      <div class="w-[120px] relative overflow-hidden">
        <VAffix class="scroll-navs" relative-element-selector=".j_main" :offset="{ top: offsetTop, bottom: 40 }"
                :scroll-affix="false">
          <ul class="mb-7">
            <li class="mb-2.5">
              <CruiseDialogShare :cruiseName="cruiseData.base.name" :cruiseid="$route.params.cruiseId">
                <button class="flex items-center justify-center h-10 w-full rounded text-dark text-sm font-medium bg-white" type="button">
                  <i class="icon ficon ficon-xingzhuangjiehe2 text-base w-[25px]"/>
                  <span class="ml-1.5">分享</span>
                </button>
              </CruiseDialogShare>
            </li>
            <li class="mb-2.5">
              <button class="flex items-center justify-center h-10 w-full rounded text-dark text-sm font-medium bg-white" type="button" @click="onToggleFavorite">
                <div class="flex items-center">
                  <i class="ficon text-base" :class="isFavorite ? 'ficon-Union' : 'ficon-a-Star16Stroke'"/>
                  <div class="ml-1.5">{{ isFavorite ? "已收藏" : "收藏" }}</div>
                </div>
              </button>
            </li>
          </ul>
          <scroll-active ref="nav" v-resize="handleWinResize" tag="ul" :offset="offsetTop" class="bg-[#F7F8FC]">
            <!-- <template v-if="winWidth >= SHOW_NAV_MIN_WIDTH"> -->
            <template>
              <li v-for="nav in left_navigation" :key="nav.type" class="scroll-navs-item scrollactive-item" :class="{
                'is-disabled': nav.disabled,
                disabled: nav.disabled,
              }" :data-section-selector="`${'.nav-' + nav.type}`">
                <i class="icon ficon text-[12px] w-[20px] flex items-center justify-center" :class="nav.icon"/>
                <!-- <i class="icon ficon" :class="[NAV_ICONS[nav.type]]" /> -->
                <span class="name">{{ nav.title }}</span>
              </li>
            </template>
            <!-- <template v-else>
							<li v-for="nav in cruiseData.left_navigation" :key="nav.type"
								class="scroll-navs-item scrollactive-item mini" :class="{
									'is-disabled': isNavDisaled(nav),
								}" :data-section-selector="`${'.nav-' + nav.type}`" v-tooltip.right="nav.title">
								<i class="icon ficon" :class="[NAV_ICONS[nav.type]]" />
							</li>
						</template> -->
          </scroll-active>
        </VAffix>
      </div>
      <!-- S 右侧区域 -->
      <div class="flex-1 overflow-hidden pb-20">
        <el-breadcrumb class="my-[25px] ml-[2px]" separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/cruise-map' }">邮轮地图</el-breadcrumb-item>
          <el-breadcrumb-item>邮轮详情</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="flex justify-between">
          <div class="w-[956px]">
            <CruiseDetailBase
              class="mb-[10px] nav-base"
              :data="cruiseData.base"
              :images_num="cruiseData.images_num"
              :images="cruiseData.images"
              :rank="cruiseData.rank"
            />
            <!-- S 地图 -->
            <client-only>
              <CruiseDetailMap v-if="isReady" class="nav-location mb-[10px]" :latitude="aisInfo.latitude"
                               :longitude="aisInfo.longitude" :flag="cruiseData.base.flag"
                               :name="cruiseData.base.name"
                               :en_name="cruiseData.base.en_name" :logo="cruiseData.base.logo"
                               :cog="aisInfo.cog"
                               :code="cruiseData.base.code" :cruise_id="cruiseId"
                               :navistatus_label="aisInfo.navistatus"
                               :update_time="aisInfo.update_time"
                               :aisInfo="aisInfo"
                               />
            </client-only>
            <!-- S 当前航次 -->
            <!-- <CruiseDetailCurrentVoyage class="nav-currentRoute mb-[10px]" :voyage="cruiseData.voyage" v-if="
              cruiseData.voyage.product_tours && cruiseData.voyage.product_tours.length
            " /> -->
            <!-- S 线路行程 -->
            <CruiseRouteDetail class="nav-routeAll mb-[10px]" :all_voyage="cruiseData.all_voyage"
                               :productType="cruiseData.class_id" v-if="cruiseData.all_voyage.length"/>
            <!-- 甲板导航 -->
            <DetailDeck class="nav-deck mb-[10px]" :data="cruiseData.decks" v-if="cruiseData.decks.length"
                        @clickDeck="clickDeck"/>
            <!-- 舱房信息 -->
            <detailCabin class="nav-cabin mb-[10px]" :cabins="cruiseData.cabins" v-if="cruiseData.cabins.length"
                         @tapImage="tapImage($event, 'cabins')"/>

            <div id="company-cruise-detail-main" ref="main" class="company-cruise-detail-main">
              <div v-if="cruiseData.restaurants.length" class="nav-restaurants px-[20px] pt-[10px] pb-[20px] bg-white rounded-sm mb-[10px]" >
                <CruiseDetailCommenTitle class="mb-[10px]" title="美食餐厅" />
                  <CruiseDetailCabinRoomThree :rooms="cruiseData.restaurants" type="restaurants" @tapImage="tapImage($event, 'restaurants')" />
              </div>
              <div class="nav-plays px-[20px] pt-[10px] pb-[20px] bg-white rounded-sm mb-[10px]" v-if="cruiseData.plays.length">
                <CruiseDetailCommenTitle class="mb-[10px]" title="娱乐设施" />
                <CruiseDetailCabinRoomThree :rooms="cruiseData.plays" type="plays" @tapImage="tapImage($event, 'plays')" />
              </div>
              <div class="nav-services px-[20px] pt-[10px] pb-[20px] bg-white rounded-sm mb-[10px]" v-if="cruiseData.services.length">
                <CruiseDetailCommenTitle class="mb-[10px]" title="邮轮服务" />
                <CruiseDetailCabinRoomThree :rooms="cruiseData.services" type="services" @tapImage="tapImage($event, 'service')" />
              </div>
              <!-- 相册  -->
              <!-- <detail-album v-if="cruiseData.photos" class="nav-9999" :data="cruiseData.photos" /> -->
            </div>
            <TextView v-if="cruiseData.base && cruiseData.base.wiki" class="nav-introduce" title="邮轮介绍" :content="cruiseData.base.wiki"/>
            <TextView v-if="cruiseData.base && cruiseData.base.review" class="nav-history" title="邮轮历史" :content="cruiseData.base.review"/>
            <!--相关视频-->
              <detailNews class="nav-video" title="相关视频" :isVideo="true" :news="cruiseData.video" v-if="cruiseData.video.length"/>
            <!-- 相关咨询 -->
            <detailNews class="nav-news" title="相关资讯" :isVideo="false" :news="cruiseData.news" v-if="cruiseData.news.length"/>
          </div>
          <!-- 右侧 -->
          <div class="w-[280px]">
            <CruiseDetailSlideRight :cruiseData="cruiseData" :onlyHasBase="onlyHasBase"/>
          </div>
        </div>
      </div>
    </div>
    <ImagePreviewView ref="ImagePreviewView"></ImagePreviewView>
  </div>
</template>

<script>
import CruiseDialogShare from "@/views/company/CruiseDialogShare.vue";
import CruiseDetailBase from "@/views/company/CruiseDetailBase.vue"; 
import CruiseDetailSlideRight from "@/views/company/CruiseDetailSlideRight.vue";
import DetailCabin from "@/views/company/CruiseDetailCabin.vue";
import DetailDeck from "@/views/company/CruiseDetailDeck.vue";
import CruiseDetailCabinRoomThree from "@/views/company/CruiseDetailCabinRoomThree.vue"
import CruiseDetailCommenTitle from "@/views/company/CruiseDetailCommenTitle.vue"
import TextView from '@/views/company/TextView.vue'

// import DetailAlbum from "@/views/company/CruiseDetailAlbum.vue";
// import CruiseDetailMap from "@/views/company/CruiseDetailMap.vue";
// import CruiseDetailCurrentVoyage from "@/views/company/CruiseDetailCurrentVoyage.vue";
import CruiseRouteDetail from "@/views/company/CruiseRouteDetail.vue";
import detailNews from "@/views/company/detailNews.vue";
import ImagePreviewView from "@/views/company/components/ImagePreviewView.vue";
import useFavorite from "@/components/cruise-map/composables/useFavorite.js";

import ScrollActive from "@/components/ScrollActive/";
import VAffix from "@/components/VAffix";
// import {generateId} from '@/utils/helpers.js'
// import ImageView from '@/views/company/components/ImageView';

import {getCruiseDetailById,getCruiseAisInfo} from "@/services/company";
// import Scroll from "@/directives/scroll/";

// import { getScrollTopPosition } from "@/utils/getScrollTop";
// import { getOffsetTop } from "@/utils/dom";
// import { getScreenWH } from "@/utils/helpers.js";
// import getScrollbarWidth from "@/utils/scrollbar-width";
import useRequest from "~/composables/useRequest";
import defineAsyncComponent from "~/utils/defineAsyncComponent";
import {
  computed,
  defineComponent,
  useFetch,
  useMeta,
  useRoute,
} from "@nuxtjs/composition-api";
import useLayout from "~/composables/useLayout";

//美食  type: 7-主餐厅 8-自助餐厅 9-特色餐饮 10-酒吧 11-VIP餐厅
//玩乐  type: 13-娱乐活动 14-船上休闲  15-运动健身  17-会展服务
//服务  type: 18-WIFI 19-套房礼遇  20-儿童服务  21-其他服务
//舱房信息 type: 23-内舱房 24-海景房 25-景观房 26-阳台房 27-套房
// const CODE_DECK = "9998"; // 甲板导航
// const CODE_ABLUM = "9999"; // 相册
// const CODE_CABIN = "9997"; // 舱房

export default defineComponent({
  name: "Company",
  layout: "Main",
  auth: false,
  // directives: { Scroll },
  components: {
    CruiseDialogShare,
    CruiseRouteDetail,
    // CruiseDetailCurrentVoyage,
    CruiseDetailSlideRight,
    CruiseDetailBase,
    DetailCabin,
    DetailDeck,
    ImagePreviewView,
    // DetailAlbum,
    ScrollActive,
    VAffix,
    CruiseDetailMap: defineAsyncComponent(() => import("@/views/company/CruiseDetailMap.vue")),
    detailNews,
    CruiseDetailCabinRoomThree,
    CruiseDetailCommenTitle,
    TextView,
  },
  head: {
    meta: [],
  },
  setup() {
    const route = useRoute();
    const {execute, state} = useRequest(
      () =>
        getCruiseDetailById({
          cruise: route.value.params.cruiseId,
        }),
      {
        left_navigation: [],
        base: {
          name: "",
          describe: "", //简述
          introduction: "", //介绍
          //视频&图片
          images: [],
          attributes: {},
        },
        cabins: [],
        restaurants: [],
        plays: [],
        decks: [],
        photos: [],
        // 当前航次
        voyage: {
          product_tours: [],
        },
        all_voyage: [],
        rank: {},
        news: [],
        video:[],
        services: [],
        company_cruise: [],
        class_cruise: [],
        home_port: [],
      },
      {
        immediate: false,
      }
    );

    // const {title, meta} =
    // const { title, meta } = useMeta();

    useFetch(async () => {
      await execute(0);
      await executeAis(0);
      isFavorite.value = state.value.collection;
      // console.log('cruiseData', state.value);
      console.log('aisInfo', aisInfo.value);
    });

    const {state:aisInfo,isReady,execute:executeAis} = useRequest(
      ()=>getCruiseAisInfo({
        cruise:route.value.params.cruiseId,
      }),
      {
        mmsi:'',
        imo:'',
        callsign:'',//呼号
        navistatus:'',//状态
        draught:'',// 吃水
        hdg:'',//船首向
        longitude:'',//经度
        latitude:'',// 纬度
        sog:'',//航速
        cog:'',//航向
        humidity:'',//湿度
        pressure:'',//气压
        swelldir:'',//涌向
        swellheight:'',//涌高
        swellperiod:'',//涌周期
        temperature:'',//温度
        visibility:'',//能见度
        waveheight:'',//浪高
        winddir:'',//风向
        windspeed:'',//风速
      },
      {
        immediate: false,
      }
    )

    useMeta(() => {
      const {base} = state.value;
      return {
        // title: state.value.base.name,
        title: `${base.name}详细信息,邮轮简介,配置信息,定位轨迹,邮轮图片,上船吧邮轮平台`,
        meta: [
          {
            name: "description",
            hid: "description",
            // content: base.introduction
            content: `上船吧邮轮平台为您提${base.name}详细信息,包括邮轮类型,吨位,首航时间,甲板,长度,宽度,载客量,舱房数量,仓房信息,工作人员,航行船速,行程信息,定位轨迹,餐厅,相关资讯,邮轮公司,海景房,阳台房,套房,内舱房,酒吧,健身房,娱乐等`,
          },
          {
            name: "keywords",
            hid: "keywords",
            // content: state.value.left_navigation.map(nav => nav.title).join(","),
            content: `${base.name},${base.name}简介,${base.name}价格,${base.name}吨位,${base.name}舱房,${base.name}娱乐,${base.name}美食,${base.name}实时位置`
          },
        ],
      }
    })
    const {isFavorite, toggleFavorite} = useFavorite();


    const {headerSize} = useLayout();
    const offsetTop = computed(() => headerSize.height);
    return {
      isReady,
      offsetTop,
      cruiseData: state,
      isFavorite,
      toggleFavorite,
      aisInfo,
    };
  },
  data() {
    return {
      SHOW_NAV_MIN_WIDTH: 0,
      // offsetTop: 0,
      scrollTop: 0,
      winWidth: 0,
    };
  },
  computed: {
    // isNavFixed() {
    // 	return this.scrollTop > this.offsetTop;
    // }
    left_navigation() {
      const cruiseData = this.cruiseData;
      const currentRouteDisabled = !(
        cruiseData.voyage.product_tours && cruiseData.voyage.product_tours.length
      );
      const routeAllDisabled = !cruiseData.all_voyage.length;
      const decksDisabled = !cruiseData.decks.length;
      const cabinDisabled = !cruiseData.cabins.length;
      const restaurantsDisabled = !cruiseData.restaurants.length;
      const playsDisabled = !cruiseData.plays.length;
      const servicesDisabled = !cruiseData.services.length;
      const newsDisabled = !cruiseData.news.length;
      // const locationDisabled = !(cruiseData.base.latitude && cruiseData.base.longitude);

      return [
        {title: "基础信息", type: "base", icon: "ficon-jichuxinxi"},
        {
          title: "当前位置",
          type: "location",
          icon: "ficon-mudedi",
          // disabled: locationDisabled,
        },
        // {
        //   title: "当前航次",
        //   type: "currentRoute",
        //   icon: "ficon-dangqianhangci",
        //   disabled: currentRouteDisabled,
        // },
        {
          title: "航次行程",
          type: "routeAll",
          icon: "ficon-a-Group75",
          disabled: routeAllDisabled,
        },
        {
          title: "甲板信息",
          type: "deck",
          icon: "ficon-jiaban",
          disabled: decksDisabled,
        },
        {
          title: "舱房信息",
          type: "cabin",
          icon: "ficon-cangfangshuliang",
          disabled: cabinDisabled,
        },
        {
          title: "美食餐厅",
          type: "restaurants",
          icon: "ficon-meishi1",
          disabled: restaurantsDisabled,
        },
        {
          title: "娱乐设施",
          type: "plays",
          icon: "ficon-yule1",
          disabled: playsDisabled,
        },
        {
          title: "邮轮服务",
          type: "services",
          icon: "ficon-gongzuorenyuan",
          disabled: servicesDisabled,
        },
        {
          title: "邮轮介绍",
          type: "introduce",
          icon: "ficon-youlunjieshao",
          disabled: !cruiseData.base.wiki,
        },
        {
          title: "邮轮历史",
          type: "history",
          icon: "ficon-youlunlishi",
          disabled: !cruiseData.base.review,
        },
        {
          title: "相关视频",
          type: "video",
          icon: "ficon-xiangguanshipin",
          disabled: !cruiseData.video.length,
        },
        {
          title: "相关资讯",
          type: "news",
          icon: "ficon-xingzhuangjiehe3",
          disabled: newsDisabled,
        },
      ];
    },
    cruiseId() {
      return this.$route.params.cruiseId;
    },
    onlyHasBase() {
      return this.left_navigation.slice(2).every(({disabled}) => disabled)
    }
  },
  mounted() {
    // this.offsetTop = getOffsetTop(this.$refs.main) + 10 - 70;
    // this.SHOW_NAV_MIN_WIDTH = (1200 / 2 + 140 + 20) * 2 + getScrollbarWidth();
  },
  methods: {
    handleScroll() {
      // this.scrollTop = getScrollTopPosition();
    },
    handleWinResize() {
      // this.winWidth = getScreenWH().w;
    },
    onToggleFavorite() {
      if (!this.$store.getters.loggedIn) {
        const dialog = this.$createLoginDialog({
          onSuccess: () => {
            this.toggleFavorite(this.cruiseId);
            dialog.hide();
          },
        }).show();
      } else {
        this.toggleFavorite(this.cruiseId);
      }
    },
    tapImage(imgPath, tabCode) {
      // console.log(event1, event2)
      // 类型看  constants/galleryEnum.js    TABS[name]
      this.$refs.ImagePreviewView.setData(tabCode, imgPath, this.cruiseId);
    },
    clickDeck(floor) {
      const {href} = this.$router.resolve(
        `/company/cruise/decknavigation?id=${this.cruiseId}&floor=${floor}`
      );
      window.open(href, "_blank");
    },
  },
});
</script>

<style lang="scss" scoped>

$nav-width: 110px;
$mini-nav-width: 50px;
.scroll-navs {
  position: absolute;
  top: 10px;
  z-index: 9;
  // left: 0;
  // margin-left: 10px;
  // background: #fff;
  // box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.05);
  // border: 1px solid #EDEFF5;
  //.nav__top {
  //  margin-bottom: 30px;
  //
  //  &__item {
  //    height: 38px;
  //    width: $nav-width;
  //    border-radius: 4px;
  //    background-color: #fff;
  //    display: flex;
  //    align-items: center;
  //    justify-content: center;
  //    cursor: pointer;
  //    color: $color-black-2;
  //    margin: 0;
  //    margin-bottom: 10px;
  //    border: none;
  //
  //    .ficon {
  //      color: $color-black-2;
  //    }
  //  }
  //}

  &-item {
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    height: 44px;
    width: $nav-width;
    padding: 0 10px;
    transition: all $primary-transition;
    margin: 0 -1px 4px;
    overflow: hidden;
    white-space: nowrap;
    font-size: 15px;
    color: #333;

    .icon {
      color: #333;
      font-size: 18px;
    }

    .name {
      margin-left: 10px;
      color: $secondary-text-color;
      // font-weight: bold;
    }

    &.is-disabled {
      cursor: not-allowed;
      pointer-events: none;

      &:hover, & {
        .icon, .name {
          color: $color-grey-6;
        }
      }

    }

    &:hover {
      color: $color-black-2;

      .name {
        color: $color-black-2;
      }
    }

    &.is-active {
      background: $color-black-2;
      border-radius: 4px;

      .icon, .name {
        color: #fff;
      }

      &::after {
        content: '';
        border: 6px solid transparent;
        position: absolute;
        top: 50%;
        margin-top: -6px;
        right: -12px;
        border-left-color: $theme-color;

      }
    }

    &.mini {
      width: $mini-nav-width;
      text-align: center;
    }
  }

  &.affix {
    position: fixed;
    // top:$top-bar-hegiht + 10;
  }
}

//@import "@/assets/scss/pages/company/cruise-detail.scss";

</style>
